import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

export class DataTableCache {
  public name?: string;
  public tableName?: string;
  public params?: string[];
  public pending?: boolean;
  public loaded?: boolean;
  public data?: object[];
  public dataSubject?: BehaviorSubject<object[]>;
}

@Injectable({
  providedIn: 'root'
})
export class CerAppStateService implements OnDestroy {
  private subscriptionManager$: Subscription = new Subscription();

  public dataTableCache = new Array<DataTableCache>();

  public ngOnDestroy(): void {
    this.subscriptionManager$.unsubscribe();
  }

  public getDataTableCache(tableName: string, params: string[] = undefined): DataTableCache {
    var tableNameLwr: string = tableName.toLowerCase();
    if (params?.length > 0) {
      params.forEach(p => tableNameLwr += "#" + p.toLowerCase());
    }
    var c: DataTableCache = this.dataTableCache.find(f => f.name == tableNameLwr);
    if (!c) {
      c = { name: tableNameLwr, tableName: tableName, params: params, pending: false, loaded: false, data: new Array<Object>(), dataSubject: new BehaviorSubject<object[]>(null) };
      this.dataTableCache.push(c);
    }
    return c;
  }

  public setDataTableCache(c: DataTableCache, data: object[]) {
    if (!c.loaded) {
      c.data = data;
      c.pending = false;
      c.loaded = true;
      c.dataSubject.next(c.data);
    }
  }
}
